import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit, FiTrash2, FiUsers, FiEye, FiCheckCircle } from 'react-icons/fi';
import { homeworkAPI } from '../../../services/api';
import { prepareHomeworkHtml } from '../../../utils/homeworkContent';
import './HomeworkPage.css';

const HomeworkPage = () => {
    const navigate = useNavigate();
    const [homework, setHomework] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadHomework();
    }, []);

    const loadHomework = async () => {
        try {
            setLoading(true);
            const response = await homeworkAPI.getAllHomework();
            // Бэкенд возвращает объект вида { homeworks: [...] }
            setHomework(response.data.homeworks || []);
        } catch (error) {
            console.error('Ошибка загрузки домашних заданий:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id, title) => {
        if (!window.confirm(`Вы уверены, что хотите удалить домашнее задание "${title}"?`)) {
            return;
        }

        try {
            await homeworkAPI.deleteHomework(id);
            setHomework(homework.filter(hw => hw.id !== id));
        } catch (error) {
            console.error('Ошибка удаления домашнего задания:', error);
            alert('Ошибка при удалении домашнего задания');
        }
    };

    const openStudentHomework = (studentId) => {
        navigate(`/admin/student/${studentId}?tab=homework`);
    };

    if (loading) {
        return <div className="homework-loading">Загрузка...</div>;
    }

    return (
        <div className="homework-page">
            <div className="homework-header">
                <h1>Домашние задания</h1>
                <button 
                    onClick={() => navigate('/admin/homework/create')}
                    className="btn-create"
                >
                    <FiPlus />
                    Создать ДЗ
                </button>
            </div>

            {homework.length === 0 ? (
                <div className="empty-state">
                    <p>Домашних заданий пока нет</p>
                    <button 
                        onClick={() => navigate('/admin/homework/create')}
                        className="btn-create-empty"
                    >
                        <FiPlus />
                        Создать первое ДЗ
                    </button>
                </div>
            ) : (
                <div className="admin-homework-list">
                    {homework.map(hw => (
                        <div key={hw.id} className="admin-homework-card">
                            <div className="admin-homework-header">
                                <h3>{hw.title}</h3>
                                <span className="homework-date">
                                    {new Date(hw.created_at).toLocaleDateString('ru-RU')}
                                </span>
                            </div>

                            <div className="admin-homework-body">
                                <div className="admin-homework-main-row">
                                    <div>
                                        <div
                                            className="admin-homework-description"
                                            dangerouslySetInnerHTML={{
                                                __html: prepareHomeworkHtml(hw.description, 'admin')
                                            }}
                                        />

                                        <div className="admin-homework-assignees">
                                            <div className="admin-homework-assignees-title">
                                                Назначено ученикам:
                                            </div>
                                            {Array.isArray(hw.students) && hw.students.length > 0 ? (
                                                <div className="admin-homework-student-chips">
                                                    {hw.students.map(student => (
                                                        <button
                                                            key={`${hw.id}-${student.id}`}
                                                            type="button"
                                                            className={`admin-homework-student-chip ${student.is_read ? 'read' : 'unread'}`}
                                                            onClick={() => openStudentHomework(student.id)}
                                                            title="Открыть ДЗ в профиле ученика"
                                                        >
                                                            {student.username || student.email || `Ученик #${student.id}`}
                                                        </button>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="admin-homework-no-assignees">Ученики не назначены</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="admin-homework-side-panel">
                                        <div className="admin-homework-stats">
                                            <span className="stat">
                                                <FiUsers />
                                                {hw.total_students || 0} студентов
                                            </span>
                                            <span className="stat success">
                                                <FiCheckCircle />
                                                {hw.read_count || 0} прочитали
                                            </span>
                                        </div>

                                        <div className="homework-actions">
                                            <button
                                                onClick={() => navigate(`/admin/homework/${hw.id}`)}
                                                className="btn-view"
                                                title="Просмотр"
                                            >
                                                <FiEye />
                                            </button>
                                            <button
                                                onClick={() => navigate(`/admin/homework/${hw.id}/edit`)}
                                                className="btn-edit"
                                                title="Редактировать"
                                            >
                                                <FiEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(hw.id, hw.title)}
                                                className="btn-delete"
                                                title="Удалить"
                                            >
                                                <FiTrash2 />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HomeworkPage;
